<template>
	<div id="app">
		<router-view></router-view>
		<div v-show="appTips.isShow" class="app_art">
			<div class="tips_nner"><span>{{appTips.appMsg}}</span></div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	export default {
		name: 'app',
		data() {
			return {
				websocket: null,
				appTips: {
					isShow: false,
					time: 0,
					appMsg: "请重新登录！"
				}
			};
		},
		watch: {
			"appTips.isShow": function(val, oldVal) {
				var ts = this;
				ts.appTips.time = self.setTimeout(function() {
					ts.appTips.isShow = false;
				}, 2000);
			}
		},
		created: function() { //
			Vue.prototype.$appTips = this.appTips;  //弹窗提示
			Vue.prototype.$msg = this.showMsg; //信息提示
			console.log("created init")
		},
		methods: {
			showMsg(msg) { //
				var ts = this;
				ts.appTips.isShow = true;
				ts.appTips.appMsg = msg;
			},
			hideAppTips() { //
				this.appTips.isShow = false;
			}
		}
	}
</script>

<style lang="scss">
	@import "./style/style";
	.size {
		clear: both;
		overflow: hidden;
		margin-top: 10px;
		line-height: 30px;
		span {
			float: left;
		}
		p {
			float: left;
			margin-left: 5px;
			margin-right: 10px;
		}
		input.txt {
			border: 1px solid #E3E3E3;
			width: 80px;
			line-height: 30px;
			text-align: center;
		}
	}
	
	.app_art {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 1000000;
		.tips_nner {
			position: absolute;
			top: 40%;
			margin-top: -40px;
			left: 50%;
			margin-left: -100px;
			padding: 0 20px;
			color: #fff;
			font-weight: 700;
			background-color: rgba(0, 0, 0, 0.8);
			min-height: 40px;
			line-height: 40px;
			min-width: 100px;
			border-radius: 8px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/App.vue